<template>
  <div class="row  m-4 mt-0">
    <div class="col-sm-12">
      <div class="row">
        <div v-if="templatesTabAvailable" class="col-sm-12">
          <div class="card card-body mb-3">
            <ul class="navbar-nav overflow-auto flex-row gap-4 mb-0">
              <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                <a href="#" @click.prevent="selectTab(tab)" class="nav-link tab" :class="{'active': activeTabName === tab}">{{ helper.trans(`requisites.templates.admin.tab_${tab}`) }}</a>
              </li>
            </ul>
          </div>
        </div>
        <PayInRequisites v-if="activeTabName === Tabs.pay_in"></PayInRequisites>
        <RequisiteTemplates v-else-if="activeTabName === Tabs.templates && templatesTabAvailable"></RequisiteTemplates>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, toRefs, reactive} from 'vue'
import {useStore} from "vuex";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PayInRequisites from "@/views/PayInRequisites.vue";
import PayOutRequisites from "@/views/PayOutRequisites.vue";
import RequisiteTemplates from "@/views/RequisiteTemplates.vue";
import {UserRole} from "@/models/enum/UserRole";

const api = new APIClient();
const notification = useNotification()

enum Tabs {
  pay_in = 'pay_in',
  templates = 'templates'
}

export default defineComponent({
  components: {
    LoaderWrapper,
    CopyButton,
    BPagination,
    PayInRequisites,
    PayOutRequisites,
    RequisiteTemplates
  },
  setup() {
    const store = useStore()
    const templatesTabAvailable = computed(() => !!store.getters.getAppData?.REQUISITES_TEMPLATES_ENABLED && !!store.getters.isAdmin)

    const state = reactive({
      activeTabName: Tabs.pay_in as Tabs
    });

    const selectTab = async (tab: Tabs) => {
      state.activeTabName = tab
    }


    onMounted(() => {
      selectTab(Tabs.pay_in)
    });

    return {
      ...toRefs(state),
      dateHelper,
      numberFormatter,
      Tabs,
      selectTab,
      templatesTabAvailable,
      helper,
      UserRole
    }
  }
})
</script>
